import requestFunctions from "../../functions/requestFunctions";


export const state = {
  BRANDS_ITEM: {},
  BRANDS_LIST: [],
  BRANDS_TABLE_DATA: [],
  BRANDS_ARRAY_DATA: [],
  BRANDS_TOTAL_ROWS: 0
}

export const getters = {
  GET_BRANDS_ITEM: (state) => {
    return state.BRANDS_ITEM;
  },
  GET_BRANDS_LIST: (state) => {
    return state.BRANDS_LIST;
  },
  GET_BRANDS_TABLE_DATA: (state) => {
    return state.BRANDS_TABLE_DATA;
  },
  GET_BRANDS_ARRAY_DATA: (state) => {
    return state.BRANDS_ARRAY_DATA;
  },
  GET_BRANDS_TOTAL_ROWS: (state) => {
    return state.BRANDS_TOTAL_ROWS;
  }
}

export const mutations = {

  UPDATE_BRANDS_ITEM(state, item) {
    state.BRANDS_ITEM = item;
  },

  UPDATE_BRANDS_LIST(state, list) {
    
    state.BRANDS_LIST = list.data;

    state.BRANDS_TOTAL_ROWS = list.total;
    list = list.data;
    
    state.BRANDS_TABLE_DATA = [];
    state.BRANDS_ARRAY_DATA = [];

    list.forEach(el => {

      state.BRANDS_TABLE_DATA.push({
        'uuid' : el.uuid,
        'id'   : el.id,
        'name' : el.name,
        'comments': el.comments,
        'country_name': el.country_name,
        'created_at' : el.created_at,
        'updated_at' : el.updated_at,
      });

      state.BRANDS_ARRAY_DATA.push({
        id: el.id,
        uuid: el.uuid,
        name: el.name
      });
    });
  },
}

export const actions = {

  async FETCH_BRANDS_ITEM({ commit }, payload) {

    let query_url = 'https://api.tradeanalytic.ru/v1/brands/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_BRANDS_ITEM', response.data);
      return response.data;
    }
  },

  async FETCH_BRANDS_LIST({ commit }, payload= {}) {

    let query_url = 'https://api.tradeanalytic.ru/v1/brands';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_BRANDS_LIST', response.data);
      return response.data;
    }
  },

  async FETCH_BRANDS_CREATE({ commit }, payload) {

    let query_url = 'https://api.tradeanalytic.ru/v1/brands';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },

  async FETCH_BRANDS_UPDATE({ commit }, payload) {

    let query_url = 'https://api.tradeanalytic.ru/v1/brands/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },

  async FETCH_BRANDS_DELETE({ commit }, payload) {

    let query_url = 'https://api.tradeanalytic.ru/v1/brands/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },
}